import _ from 'lodash';
import * as constants from '@/util/constants';
import CampaignTarget from './campaign-target';

export const AD_FORMAT_IMAGE = 'image';
export const AD_FORMAT_CAROUSEL = 'carousel';
export const AD_FORMAT_SLIDESHOW = 'slideshow';
export const AD_FORMAT_VIDEO = 'video';

export default class Campaign {
  constructor() {
    this.id = null;
    this.target = new CampaignTarget();
    this.potentialReach = 0;
    this.type = '';
    this.mode = '';
    this.package = null;
  }
}

export function getNextIterationStartDate(campaignStartDate, periodType,
  periodLength, minStartDate) {
  if (campaignStartDate && campaignStartDate.isValid() && periodType !== null) {
    const startDate = campaignStartDate.clone();
    if (startDate.isBefore(minStartDate)) {
      const iterationsCount = (minStartDate.diff(startDate, periodType)) / periodLength;
      startDate.add(periodLength * (iterationsCount + 1), periodType);
    }
    return startDate;
  }
  return null;
}

export function isIterationDate(date, periodType, periodLength, campaignStartDate) {
  if (['month', 'months'].includes(periodType)) {
    const months = Math.round(date.diff(campaignStartDate, 'months', true));
    if ((months % periodLength) === 0) {
      if ((date.date() === campaignStartDate.date()) ||
        (date.daysInMonth() < campaignStartDate.date() && date.daysInMonth() === date.date())) {
        return true;
      }
      return false;
    }
  } else {
    // day interval - check if subscription matches. Not FULLY tested as 1 month is used
    const days = date.diff(campaignStartDate.date(), 'days');
    if ((days % periodLength) === 0) {
      return true;
    }
  }
  return false;
}

export function getSubscriptionPeriodType(config) {
  const periodType = _.get(config, 'campaign_subscription.period_type', constants.CAMPAIGN_SUBSCRIPTION.periodType);
  if (!constants.CAMPAIGN_SUBSCRIPTION.periodTypes.includes(periodType)) {
    return null;
  }
  return periodType;
}

export function getSubscriptionPeriodLength(config) {
  return _.get(config, 'campaign_subscription.period_length', constants.CAMPAIGN_SUBSCRIPTION.periodLength);
}



// WEBPACK FOOTER //
// ./src/models/campaign.js